export default __webpack_public_path__ + "static/media/file_ppt_32.8b49236e.svg";